__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-common/v8_6_2/";